import moment from 'moment'

class BasePropertiesGenerator {

  /**
   * 
   * @param {String} sessionId - id текущей сессии
   * @param {String} user - пользователь текущей сессии
   * @param {String} page - страница в которой было совершено действие
   * @param {String} type - тип действия
   * @returns 
   */
  getBaseProperties(sessionId, user, page, type) {
    const data = {
      type,
      page,
      sessionId,
      time: moment().format('LLL'),
      user: user || 'unauthorized'
    }

    return data
  }

  /**
   * The function how check and parse userAgent to get browser name
   * @returns {String} return the name of the user browser
   */
   getBrowserName() {
    const agent = navigator.userAgent.toLowerCase()

    switch (true) {
      case agent.indexOf('edge') > -1:
        return 'MS Edge'
      case agent.indexOf('edg/') > -1:
        return 'Edge ( chromium based)'
      case agent.indexOf('opr') > -1 && !!window.opr:
        return 'Opera'
      case agent.indexOf('chrome') > -1 && !!window.chrome:
        return 'Chrome'
      case agent.indexOf('trident') > -1:
        return 'MS IE'
      case agent.indexOf('firefox') > -1:
        return 'Mozilla Firefox'
      case agent.indexOf('safari') > -1:
        return 'Safari'
      default:
        return 'other'
    }
  }
}

export default new BasePropertiesGenerator()